import React, { useState, useEffect } from 'react'
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  AppBar,
  Toolbar,
  IconButton,
} from '@mui/material'
import { Logout, Dashboard, Devices } from '@mui/icons-material'

// API Configuration
const API_BASE_URL = 'https://gemini-billing-backend.krapphead.workers.dev'

interface User {
  id: string
  username: string
  role: string
}

interface TV {
  id: string
  name: string
  ip: string
  customName?: string
  price?: number
  status: 'on' | 'off' | 'unknown'
}

interface DashboardPageProps {
  user: User | null
  onLogout: () => void
  onNavigate: (page: string) => void
}

export const DashboardPage: React.FC<DashboardPageProps> = ({ user, onLogout, onNavigate }) => {
  const [tvs, setTvs] = useState<TV[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchTVs()
  }, [])

  const fetchTVs = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/sheets/tvs`)
      if (response.ok) {
        const data = await response.json()
        setTvs(data.tvs || [])
      }
    } catch (error) {
      console.error('Error fetching TVs:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Gemini Billing System
          </Typography>
          <IconButton color="inherit" onClick={() => onNavigate('dashboard')}>
            <Dashboard />
          </IconButton>
          <IconButton color="inherit" onClick={() => onNavigate('devices')}>
            <Devices />
          </IconButton>
          <Button color="inherit" onClick={onLogout} startIcon={<Logout />}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary" gutterBottom>
          Welcome, {user?.username} ({user?.role})
        </Typography>

        <Grid container spacing={3} sx={{ mt: 2 }}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Total TVs
                </Typography>
                <Typography variant="h3" color="primary">
                  {loading ? '...' : tvs.length}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Active TVs
                </Typography>
                <Typography variant="h3" color="success.main">
                  {loading ? '...' : tvs.filter(tv => tv.status === 'on').length}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
} 